<template>
  <div class="assets" @scroll="handleScroll">
    <div class="head">
      <img @click="back" src="@/assets/images/back.png" class="arrow_img" />
      <span>{{ $t('lang252') }}</span>
    </div>
    <div class="pd">
      <div class="">
        <div class="total_box">
          <div class="total_box_item" v-for="(item, index) in tabList" :key="index" @click="changeTab(item, index)">
            <div :class="[tabIndex == item.index ? 'total total_active' : 'total']">
              <img :src="tabIndex == item.index ? item.icon_active : item.icon" alt="" />
            </div>
            <div>
              <span class="text">{{ item.text }}</span>
            </div>
          </div>
        </div>

        <template v-if="tabIndex == 0">
          <div class="sort-box">
            <div class="sort-item" v-for="(item, index) in sortList" :key="index">
              <span>{{ item.key }}</span>
              <span>（{{ item.value }}）</span>
            </div>
          </div>
          <div class="bare" v-if="total <= 0">
            <span>{{ $t('lang60') }}</span>
          </div>
          <div v-else>
            <div class="list">
              <div v-for="(item, index) in list" :key="index" class="li">
                <div class="box">
                  <div class="box_item">
                    <span class="mobile">{{ item.phone || item.nickname }}</span>
                    <div class="f-row">
                      <span
                        :class="[
                          item.address_level == 1
                            ? 'address level1'
                            : item.address_level == 2
                            ? 'address level2'
                            : item.address_level == 3
                            ? 'address level3'
                            : item.address_level == 4
                            ? 'address level4'
                            : item.address_level >= 5
                            ? 'address level5'
                            : 'address',
                        ]"
                      >
                        {{ $t('lang35') }} {{ item.address.slice(0, 6) + '****' + item.address.slice(item.address.length - 6, item.address.length) }}
                      </span>
                      <img src="@/assets/images/trade/copy.png" alt="" class="copys" @click="copy(item.address)" :data-clipboard-text="item.address" />
                    </div>

                    <span class="key">{{ $t('lang96') }}{{ dateFormatFn(item.create_time) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="tabIndex == 1">
          <van-popup v-model="activationShow" round style="width: 80%" @close="closeActive">
            <div class="bind_box">
              <van-icon name="cross" class="close" size="20" @click="closeActive" />
              <div class="title">{{ $t('lang500') }}</div>
              <div class="sub-title">{{ $t('lang501') }}</div>
              <div class="address_field">
                <van-field v-model="activationCode" type="text" input-align="center" class="input1" />
              </div>
              <div class="bind_button" @click="activeSubmit">
                <span>{{ $t('lang502') }}</span>
              </div>
            </div>
          </van-popup>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { homeApi } from '@/api/index';
import { dateFormat } from '@/utils/formatTool.js';
import Clipboard from 'clipboard';
export default {
  data() {
    return {
      page: 1,
      loading: false,
      finished: false,
      total: 0,
      nickname: '',
      assets: 0,
      list: [],
      direct_super: {
        one: 0,
        two: 0,
      },
      tabList: [
        {
          icon: require('@/assets/images/icon_1_1.png'),
          icon_active: require('@/assets/images/icon_1.png'),
          text: this.$t('lang252'),
          index: 0,
        },
        {
          icon: require('@/assets/images/icon_2_1.png'),
          icon_active: require('@/assets/images/icon_2.png'),
          text: this.$t('lang498'),
          index: 1,
        },
        {
          icon: require('@/assets/images/icon_3_1.png'),
          icon_active: require('@/assets/images/icon_3.png'),
          text: this.$t('lang499'),
          index: 2,
        },
      ],
      tabIndex: 0,
      sortList: [
        {
          key: this.$t('lang201'),
          value: 0,
          index: 0,
        },
        {
          key: this.$t('lang503'),
          value: 0,
          index: 1,
        },
        {
          key: this.$t('lang504'),
          value: 0,
          index: 2,
        },
        {
          key: this.$t('lang505'),
          value: 0,
          index: 3,
        },
      ],
      activationShow: true,
      activationCode: '',
    };
  },
  mounted() {
    this.getChaList();
    this.getCommunityCount();
    this.direct_super = JSON.parse(localStorage.getItem('userinfo')).direct_super;
  },
  methods: {
    //返回上一页
    back() {
      this.$router.back();
    },
    dateFormatFn(date) {
      return dateFormat(new Date(date * 1000), 'yyyy-MM-dd hh:mm:ss');
    },
    copy(address) {
      if (address) {
        var clipboard = new Clipboard('.copys');
        clipboard.on('success', e => {
          this.$toast(this.$t('lang45'));
          clipboard.destroy(); // 释放内存
        });
        clipboard.on('error', e => {
          this.$toast(this.$t('lang46'));
          clipboard.destroy(); // 释放内存
        });
      }
    },
    handleScroll(event) {
      const container = event.target;
      const scrollTop = container.scrollTop; // 滚动距离
      const scrollHeight = container.scrollHeight; // 内容总高度
      const clientHeight = container.clientHeight; // 可视区域高度
      // 判断是否滑动到底部
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        console.log('Bottom');
        if (this.page != -1) {
          this.page++; // 页数加 1
          this.getChaList(); // 触发加载更多
        }
      }
    },
    getCommunityCount() {
      homeApi.getCommunityCount({}).then(res => {
        if (res.code == 200) {
          res.data.forEach(element => {
            element.level == 1 ? (this.sortList[1].value = element.num) : '';
            element.level == 2 ? (this.sortList[2].value = element.num) : '';
            element.level == 3 ? (this.sortList[3].value = element.num) : '';
          });
        } else {
        }
      });
    },
    getChaList() {
      homeApi.getChaList({ page: this.page }).then(res => {
        if (res.code == 200) {
          // this.list = res.data.data.data;
          this.total = res.data.total;
          this.sortList[0].value = this.total;
          if (this.list.length >= res.data.data.total) {
            this.page = -1; // 重置为 -1，表示没有更多数据
          } else {
            this.list = [...this.list, ...res.data.data.data];
            console.log(this.list.length);
            if (this.list.length >= res.data.data.total) {
              this.page = -1; // 重置为 -1，表示没有更多数据
            }
          }
        } else {
        }
      });
    },
    navigation(name, query) {
      console.log(query);
      if (query.coin_type == 'server') {
        this.$router.push({ name: 'orders' });
      } else if (query.coin_type == 'btc' || query.coin_type == 'filecoin' || query.coin_type == 'tao') {
        return;
      } else {
        this.$router.push({ name, query });
      }
    },
    changeNav(item, index) {
      this.navIndex = index;
    },
    changeTab(item, index) {
      this.tabIndex = index;
      if (this.tabIndex == 1) {
        this.activationShow = true;
      } else if (this.tabIndex == 2) {
        this.$router.push({ name: 'createCode' });
      }
    },
    closeActive() {
      this.activationShow = false;
      this.tabIndex = 0;
    },
    activeSubmit() {
      if (!this.activationCode) {
        return;
      }
      homeApi.activateCode({ code_no: this.activationCode }).then(res => {
        if (res.code == 200) {
          this.activationCode = '';
          this.$toast(this.$t('lang512'));
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(#000, 0.8);
  letter-spacing: 1.5px;
  font-weight: 550;
  background: #fff;
  padding: 14px 0;
  z-index: 99;
  .arrow_img {
    position: absolute;
    left: 20px;
    width: 10px;
    height: 16px;
    // transform: translate(0, -50%);
  }
}
.f-sb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.f-sa {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.f-sb-n {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.f-col {
  display: flex;
  flex-direction: column;
}
.f-row {
  display: flex;
  align-items: center;
}
.assets {
  height: 100vh;
  overflow: auto;
  padding: 50px 0 0;
  // background-color: #fafbfc;
  .top {
    color: #000;
    padding-bottom: 16px;
    margin: 0 6px;
  }
  .navbar {
    color: #000;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    span {
      color: #aaaaaa;
      width: 50%;
      font-size: 14px;
      text-align: center;
      line-height: 50px;
    }
  }
  .pd {
    padding: 4px;
    margin-top: 4px;
    background-color: #fff;
  }
  .total_box {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // position: relative;
    font-size: 12px;
    color: #fff;
    height: 120px;
    // border-radius: 16px;
    padding: 30px 20px;
    box-sizing: border-box;
    border-radius: 10px;
    margin: 10px;
    background: linear-gradient(to right, #1ab986, #25d7bb);

    &_item {
      display: flex;
      align-items: center;
      flex-direction: column;
      width: 30%;

      .text {
        display: inline-block;
        color: rgba(#fff, 1);
        font-size: 15px;
        font-weight: 600;
        width: 100px;
        text-align: center;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap; //溢出不换行
      }
    }

    .total {
      width: 50px;
      height: 50px;
      padding: 10px;
      margin-bottom: 10px;
      border-radius: 50%;
      border: 2px solid #fff;

      img {
        width: 100%;
        height: 100%;
      }
    }
    .total_active {
      background-color: #fff;
    }

    .buy {
      position: absolute;
      right: 14px;
      bottom: 14px;

      &_btn {
        color: #29b286;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        background-color: #ffffff;
        border: none;
        padding: 0 16px;
        white-space: nowrap;
        border-radius: 30px;
      }
    }
  }

  .sort-box {
    color: #000;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;
    margin: 16px 10px 0;
    border-bottom: 1px solid #f0f0f0;

    .sort-item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      text-align: center;
      span:first-child {
        max-width: 100px;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap; //溢出不换行
      }
    }
  }

  .bare {
    text-align: center;
    font-size: 14px;
    padding: 60px 14px;
    color: #888;
  }
  .list {
    border-radius: 20px;
    padding: 0 8px;
    margin-top: 16px;
    background-color: #fff;
    margin: 16px 6px;
    .li {
      // display: flex;
      // align-items: center;
      // justify-content: space-between;
      font-size: 14px;
      color: rgba(51, 51, 51, 1);
      padding: 0 0 18px;

      .box {
        padding-bottom: 18px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 0.5px solid rgba(190, 190, 190, 0.15);
        &_item {
          display: flex;
          flex-direction: column;
          .key {
            color: #aaa;
            font-size: 12px;
          }
          .address {
            font-size: 13px;
            color: #686868;
            display: flex;
            align-items: center;
            padding: 10px 0;
          }
          .mobile {
            font-size: 14px;
            color: #000;
            font-weight: 550;
          }
          .level1 {
            color: #8b4513 !important;
            border-radius: 6px;
            padding: 2px 6px;
            background-color: #000;
          }
          .level2 {
            color: silver !important;
            border-radius: 10px;
            padding: 2px 6px;
            background-color: #000;
          }
          .level3 {
            color: gold !important;
            border-radius: 10px;
            padding: 2px 6px;
            background-color: #000;
          }
          .level4 {
            color: #00a733 !important;
            border-radius: 10px;
            padding: 2px 6px;
            background-color: #000;
          }
          .level5 {
            color: rgb(132, 43, 248) !important;
            border-radius: 10px;
            padding: 2px 6px;
            background-color: #000;
          }
        }
      }
    }
  }
  .copys {
    width: 14px;
    height: 14px;
    margin-left: 4px;
  }

  .bind_box {
    font-size: 15px;
    text-align: center;
    color: #000;
    .close {
      position: absolute;
      right: 20px;
      top: 20px;
    }
    .title {
      padding: 20px 20px 26px;
    }
    .sub-title {
      color: #b3b3b3;
      letter-spacing: 0.5px;
    }
    .address_field {
      padding: 10px 0;
      margin: 0 30px 16px;
    }
    .input1 {
      height: 35px;
      line-height: 35px;
      text-align: center;
      border-radius: 10px;
      background-color: #ebebeb;
    }
    .bind_button {
      color: #fff;
      text-align: center;
      font-size: 14px;
      letter-spacing: 1px;
      border: none;
      padding: 6px 0;
      margin: 0px 30px 20px;
      border-radius: 30px;
      background-color: #1dc297;
      // border-top: 1px solid #cccccc9d;
    }
  }
  ::v-deep .van-overlay {
    background-color: rgba(#000, 0.2);
  }
}
</style>